import { reactive } from 'vue'
import axios from '@/axios'

const fileUploader = reactive({
  error: '',
  files: [],
  dropped: 0,
})

export const useFileUploader = () => {
  const getFileUrl = async params => {
    let fileData = []
    const res = await axios.post(`/download/resources`, { params })
    res.data.result.forEach(file => {
      if (file.id === params[0].resource_id) {
        fileData = file
      }
    })
    return fileData
  }

  const downloadOrPreviewFromS3 = async (
    documentId,
    type,
    fileId,
    fileName,
  ) => {
    let params = []
    params = [
      {
        document_id: documentId,
        document_type: type,
        resource_id: fileId.name,
      },
    ]

    // s3から資料のパスを取得
    const res = await getFileUrl(params)
    //MIMEからファイルの形式を判断し表示またはダウンロード
    if (
      res.mime.startsWith('image/png') === true ||
      res.mime.startsWith('image/jpeg') === true ||
      res.mime.startsWith('application/pdf') === true
    ) {
      window.open(res.url, 'imgwindow', 'width=866,height=580')
    } else if (
      res.mime.startsWith(
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ) === true ||
      res.mime.startsWith('application/vnd.ms-excel') === true ||
      res.mime.startsWith(
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ) ||
      res.mime.startsWith('application/msword') === true
    ) {
      const a = document.createElement('a')
      a.href = res.url
      a.download = fileName
      a.style.visibility = 'hidden'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
  return { fileUploader, getFileUrl, downloadOrPreviewFromS3 }
}
